
import React, { useState, useEffect } from 'react';
import securityConfig from "./security.json"

export default function App() {
 
  const [notifications, setNotifications] = useState([]);

  useEffect(() => {
    if (securityConfig.notification?.data) {
      setNotifications(securityConfig.notification.data);
    }
  }, []);

  return (
    <div className="min-h-screen bg-gray-100 flex items-center justify-center p-4 sm:p-6 lg:p-8 font-sans">
      <div className="bg-white rounded-lg shadow-xl p-6 w-full max-w-md">
        {/* Header */}
        <h2 className="text-2xl font-semibold text-gray-800 mb-4 pb-2 border-b border-gray-200">
          {/* Security Notifications ({notifications.length}) */}
        </h2>

        
        {notifications.length === 0 ? (
          <div className="text-center py-8 text-gray-500 text-lg">
            {securityConfig.notification.notify}
          </div>
        ) : (
         
          <div className="space-y-4">
            {notifications.map((notification) => (
              <div
                key={notification.id}
                className="flex flex-col sm:flex-row justify-between items-start sm:items-center p-3 bg-gray-50 rounded-md border border-gray-200"
              >
                <div className="flex-1">
                  <div className="flex items-center mb-1 sm:mb-0">
                    <span className="text-base font-medium text-gray-700 mr-2">
                      {notification.title}
                    </span>
                    <span className="inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium bg-red-100 text-red-800">
                      {notification.severity}
                    </span>
                  </div>
                  <p className="text-sm text-gray-500 mt-1 sm:mt-0">
                    {notification.description}
                  </p>
                </div>
                <div className="text-sm text-gray-400 mt-2 sm:mt-0 sm:ml-4 flex-shrink-0">
                  {notification.time}
                </div>
              </div>
            ))}
          </div>
        )}
      </div>
    </div>
  );
}
